import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { GET_AVAILABLE_SKILLS, GET_AVAILABLE_SMART_INBOX_TRIGGERS, GET_AVAILABLE_TOOL_PROVIDERS } from '../queries.ts';

export const useAvailableAgentData = () => {
    const { data: availableSkillsData, refetch: refetchAvailableSkills } = useQuery(GET_AVAILABLE_SKILLS);
    const availableSkills = useMemo(() => availableSkillsData?.availableSkills || [], [availableSkillsData]);

    const { data: availableToolProvidersData, refetch: refetchAvailableToolProviders } =
        useQuery(GET_AVAILABLE_TOOL_PROVIDERS);
    const availableToolProviders = useMemo(
        () => availableToolProvidersData?.availableToolProviders || [],
        [availableToolProvidersData]
    );
    const availableToolNames = useMemo(
        () => availableToolProviders.flatMap((p) => p.toolNames).filter(Boolean),
        [availableToolProviders]
    );

    const { data: availableSmartInboxTriggersData, refetch: refetchAvailableSmartInboxTriggers } = useQuery(
        GET_AVAILABLE_SMART_INBOX_TRIGGERS
    );
    const availableSmartInboxTriggers = useMemo(
        () => availableSmartInboxTriggersData?.availableSmartInboxTriggers || [],
        [availableSmartInboxTriggersData]
    );

    return {
        availableSkills,
        refetchAvailableSkills,
        availableToolProviders,
        refetchAvailableToolProviders,
        availableToolNames,
        availableSmartInboxTriggers,
        refetchAvailableSmartInboxTriggers,
    };
};
